import { ICustomContent } from "./ICustomConfiguration";
import * as React from 'react';

export const CustomContent: ICustomContent = {
    UserProfile: {
        RegisterBefore: undefined,
        RegisterAfter: undefined,
        UserAgreement: undefined,
        UserAgreementCheckbox: undefined
    },
    Survey: {
        SubmitSuccessMessage: "Thank you. Survey successfully submitted"
    }
}